import { Link } from "react-router-dom";
import { routes } from "routes";
import "./styles/ToastMessage.scss";

interface IToastMessageProps {
  id: string;
}

export const ToastMessage = ({ id }: IToastMessageProps) => {
  return (
    <div className="ToastMessage">
      A niche named {id} already exists. Click <Link to={routes.niche(id)}>here</Link> to see it
    </div>
  );
};
